import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Mountain } from 'lucide-react';
import { Button } from './ui/button';
import { APPLY_URL } from '../config';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Floor Plans', path: '/floor-plans' },
    { name: 'Amenities', path: '/amenities' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'FAQs', path: '/faqs' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50 transition-all duration-300 backdrop-blur-lg bg-white/95">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-all duration-500 group">
            <div className="relative">
              <Mountain className="w-11 h-11 text-[#FF5722] transition-transform duration-500 group-hover:scale-110" strokeWidth={2.5} />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-1.5 h-1.5 bg-[#FF5722] rounded-full group-hover:scale-150 transition-transform duration-500"></div>
              </div>
            </div>
            <div className="flex flex-col leading-[1.1]">
              <span className="text-sm font-black text-gray-900 tracking-[0.15em] transition-all duration-300">THE SUMMIT</span>
              <span className="text-sm font-black text-[#FF5722] tracking-[0.15em] transition-all duration-300">ON KING</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-semibold transition-all duration-300 hover:text-[#FF5722] relative group ${ 
                  isActive(link.path) ? 'text-[#FF5722]' : 'text-gray-700'
                }`}
              >
                {link.name}
                <span className={`absolute -bottom-1 left-0 w-full h-0.5 bg-[#FF5722] transform origin-left transition-transform duration-300 ${
                  isActive(link.path) ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                }`}></span>
              </Link>
            ))}
            <a
              href={APPLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-[#FF5722] hover:bg-white text-white hover:text-[#FF5722] border-2 border-[#FF5722] font-bold px-6 py-2.5 rounded-sm transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5 tracking-wide text-sm"
            >
              APPLY
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-gray-700 hover:text-[#FF5722] transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="flex flex-col py-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 text-base font-medium transition-colors hover:bg-gray-50 ${
                  isActive(link.path) ? 'text-[#FF5722] bg-gray-50' : 'text-gray-700'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <div className="px-4 py-3">
              <a
                href={APPLY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full inline-flex items-center justify-center bg-[#FF5722] hover:bg-[#F4511E] text-white font-semibold px-6 py-3 rounded-md transition-colors"
              >
                APPLY
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;